package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.InfoW500Rounded: ImageVector
    get() {
        if (_infoW500Rounded != null) {
            return _infoW500Rounded!!
        }
        _infoW500Rounded = Builder(name = "InfoW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(511.01f, 671.06f)
                quadToRelative(12.58f, -12.54f, 12.58f, -31.06f)
                verticalLineToRelative(-156.41f)
                quadToRelative(0.0f, -18.53f, -12.58f, -31.06f)
                quadTo(498.43f, 440.0f, 480.0f, 440.0f)
                reflectiveQuadToRelative(-31.01f, 12.53f)
                quadToRelative(-12.58f, 12.53f, -12.58f, 31.06f)
                lineTo(436.41f, 640.0f)
                quadToRelative(0.0f, 18.52f, 12.58f, 31.06f)
                quadToRelative(12.58f, 12.53f, 31.01f, 12.53f)
                reflectiveQuadToRelative(31.01f, -12.53f)
                close()
                moveTo(511.85f, 351.91f)
                quadToRelative(12.93f, -12.88f, 12.93f, -31.91f)
                reflectiveQuadToRelative(-12.87f, -31.91f)
                quadToRelative(-12.88f, -12.87f, -31.91f, -12.87f)
                reflectiveQuadToRelative(-31.91f, 12.87f)
                quadToRelative(-12.87f, 12.88f, -12.87f, 31.91f)
                reflectiveQuadToRelative(12.93f, 31.91f)
                quadToRelative(12.94f, 12.87f, 31.85f, 12.87f)
                quadToRelative(18.91f, 0.0f, 31.85f, -12.87f)
                close()
                moveTo(480.0f, 888.13f)
                quadToRelative(-84.91f, 0.0f, -159.34f, -32.12f)
                quadToRelative(-74.44f, -32.12f, -129.5f, -87.17f)
                quadToRelative(-55.05f, -55.06f, -87.17f, -129.5f)
                quadTo(71.87f, 564.91f, 71.87f, 480.0f)
                reflectiveQuadToRelative(32.12f, -159.34f)
                quadToRelative(32.12f, -74.44f, 87.17f, -129.5f)
                quadToRelative(55.06f, -55.05f, 129.5f, -87.17f)
                quadToRelative(74.43f, -32.12f, 159.34f, -32.12f)
                reflectiveQuadToRelative(159.34f, 32.12f)
                quadToRelative(74.44f, 32.12f, 129.5f, 87.17f)
                quadToRelative(55.05f, 55.06f, 87.17f, 129.5f)
                quadToRelative(32.12f, 74.43f, 32.12f, 159.34f)
                reflectiveQuadToRelative(-32.12f, 159.34f)
                quadToRelative(-32.12f, 74.44f, -87.17f, 129.5f)
                quadToRelative(-55.06f, 55.05f, -129.5f, 87.17f)
                quadTo(564.91f, 888.13f, 480.0f, 888.13f)
                close()
                moveTo(480.0f, 797.13f)
                quadToRelative(133.04f, 0.0f, 225.09f, -92.04f)
                quadToRelative(92.04f, -92.05f, 92.04f, -225.09f)
                quadToRelative(0.0f, -133.04f, -92.04f, -225.09f)
                quadToRelative(-92.05f, -92.04f, -225.09f, -92.04f)
                quadToRelative(-133.04f, 0.0f, -225.09f, 92.04f)
                quadToRelative(-92.04f, 92.05f, -92.04f, 225.09f)
                quadToRelative(0.0f, 133.04f, 92.04f, 225.09f)
                quadToRelative(92.05f, 92.04f, 225.09f, 92.04f)
                close()
                moveTo(480.0f, 480.0f)
                close()
            }
        }
        .build()
        return _infoW500Rounded!!
    }

private var _infoW500Rounded: ImageVector? = null
